import { Modal } from './Modal';
import { formatShortcutKey } from '@/hooks/useKeyboardShortcuts';
import styles from './KeyboardShortcutsModal.module.css';

interface Shortcut {
  key: string;
  ctrl?: boolean;
  shift?: boolean;
  alt?: boolean;
  description: string;
  category: string;
}

interface KeyboardShortcutsModalProps {
  isOpen: boolean;
  onClose: () => void;
  shortcuts: Shortcut[];
}

export function KeyboardShortcutsModal({ isOpen, onClose, shortcuts }: KeyboardShortcutsModalProps) {
  // Group shortcuts by category
  const categories = shortcuts.reduce((acc, shortcut) => {
    if (!acc[shortcut.category]) {
      acc[shortcut.category] = [];
    }
    acc[shortcut.category].push(shortcut);
    return acc;
  }, {} as Record<string, Shortcut[]>);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Keyboard Shortcuts" size="md">
      <div className={styles.content}>
        {Object.entries(categories).map(([category, categoryShortcuts]) => (
          <div key={category} className={styles.category}>
            <h3 className={styles.categoryTitle}>{category}</h3>
            <div className={styles.shortcutList}>
              {categoryShortcuts.map((shortcut, index) => (
                <div key={index} className={styles.shortcutItem}>
                  <span className={styles.description}>{shortcut.description}</span>
                  <kbd className={styles.key}>{formatShortcutKey(shortcut)}</kbd>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className={styles.tip}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4M12 8h.01" />
          </svg>
          <span>Press <kbd>Shift + ?</kbd> anytime to show this help</span>
        </div>
      </div>
    </Modal>
  );
}
